import { ItemJob } from "../models/sales";
import { handleGetConvertValue } from "./converts";
import { ItemJobStatus } from "./enums";
import { getMeasurement, getWeightMeasurement } from "./getMeasurement";

interface CalcTotalItem {
  items?: ItemJob[];
  measurement: ReturnType<typeof getMeasurement>;
  weightMeasurement: ReturnType<typeof getWeightMeasurement>;
}

export const calcTotalItems = (params: CalcTotalItem) => {
  const { items, weightMeasurement, measurement } = params;

  let totalVolume = 0;
  let totalWeight = 0;
  let totalQuantity = 0;

  if (items && items?.length > 0) {
    items?.forEach((item) => {
      if (item?.status !== ItemJobStatus.VOID) {
        totalVolume += (item?.volume || 0) * (item?.quantity || 1);
        totalWeight += item?.weight || 0;
        totalQuantity += item?.quantity || 1;
      }
    });
  }

  return {
    totalVolume: handleGetConvertValue(totalVolume, measurement?.code, measurement?.decimalPlaces),
    totalWeight: handleGetConvertValue(
      totalWeight,
      weightMeasurement?.code,
      weightMeasurement?.decimalPlaces
    ),
    totalQuantity,
  };
};
